// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  height: 100%;
  align-items: center;
  margin-left: auto;
  margin-right: 16px;
`;
